import { render } from "./StoreCarNumber.vue?vue&type=template&id=f0f33628&scoped=true"
import script from "./StoreCarNumber.vue?vue&type=script&lang=js"
export * from "./StoreCarNumber.vue?vue&type=script&lang=js"

import "./StoreCarNumber.vue?vue&type=style&index=0&id=f0f33628&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f0f33628"

export default script